<div>
    <div *ngFor="let widget of widgets" class="flex flex-wrap gap-4 justify-center">
        <div
            class="w-60 bg-white shadow-sm rounded-xl p-2 flex flex-col items-center gap-2 transition-transform hover:scale-105">
            <div class="w-10 h-10 rounded-full bg-blue-200 flex justify-center items-center shadow">
                <i class="fa-solid fa-calendar text-blue-700 text-lg"></i>
            </div>
            <div class="text-center">
                <p class="text-sm text-gray-500">{{'CARBON.YEAR' | translate}}</p>
                <p class="text-xl font-bold text-gray-800">{{ widget.osde_year }}</p>
            </div>
        </div>
        <div
            class="w-60 bg-white shadow-sm rounded-xl p-2 flex flex-col items-center gap-2 transition-transform hover:scale-105">
            <div class="w-10 h-10 rounded-full bg-green-200 flex justify-center items-center shadow">
                <i class="fa-solid fa-leaf text-green-700 text-lg"></i>
            </div>
            <div class="text-center">
                <p class="text-sm text-gray-500">{{'CARBON.TOTAL_CO' | translate}}</p>
                <p class="text-xl font-bold text-gray-800">
                    {{ widget.total_emissions }}
                    <span class="text-xs">{{'CARBON.KG' | translate}}</span>
                  </p>                  
            </div>
        </div>
        <div
            class="w-60 bg-white shadow-sm rounded-xl p-2 flex flex-col items-center gap-2 transition-transform hover:scale-105">
            <div class="w-10 h-10 rounded-full bg-orange-200 flex justify-center items-center shadow">
                <i class="fa-solid fa-ruler-combined text-orange-700 text-lg"></i>
            </div>
            <div class="text-center">
                <p class="text-sm text-gray-500">{{'CARBON.TOTAL_SIZE' | translate}}</p>
                <p class="text-xl font-bold text-gray-800">
                    {{ widget.size }}
                    <span class="text-xs">{{'CARBON.HA' | translate}}</span>
                  </p>                  
            </div>
        </div>
        <div
            class="w-60 bg-white shadow-sm rounded-xl p-2 flex flex-col items-center gap-2 transition-transform hover:scale-105">
            <div class="w-10 h-10 rounded-full bg-red-200 flex justify-center items-center shadow">
                <i class="fa-solid fa-vial text-red-700 text-lg"></i>
            </div>
            <div class="text-center">
                <p class="text-sm text-gray-500">{{'CARBON.TOTAL_NITROGEN' | translate}}</p>
                <p class="text-xl font-bold text-gray-800">
                    {{ widget.total_nitrogen }}
                    <span class="text-xs">{{'CARBON.KG' | translate}}</span>
                  </p>                  
            </div>
        </div>
    </div>
    <div class="w-full flex">
        <div [ngClass]="!verticalChart ? 'w-6/12' : 'w-4/12'">
            <app-charts [carbonBarChartOptions]="barChartOptions"></app-charts>
        </div>
        <div [ngClass]="!verticalChart ? 'w-6/12' : 'w-4/12'">
            <app-charts [carbonPieChartOptions]="pieChartOptions"></app-charts>
        </div>
        <div *ngIf="verticalChart" class="w-4/12">
            <app-charts [carbonBarVerticalChartOptions]="barVerticalChartOptions"></app-charts>
        </div>
    </div>
</div>